import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Draggable } from 'gsap/Draggable';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectCreative, EffectFade, Pagination, Navigation, Thumbs } from 'swiper/modules';

// GSAP Configuration
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.Draggable = Draggable;
window.ScrollToPlugin = ScrollToPlugin;
window.gsap.registerPlugin(ScrollTrigger, Draggable, ScrollToPlugin);

// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-creative';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
window.Swiper = Swiper;
Swiper.use([Autoplay, EffectCreative, EffectFade, Pagination, Navigation, Thumbs]);

// Components
import parallaxModule from './parallax.js';

// Modules
parallaxModule();

// Global
window.Alpine = Alpine;

// Inits
Alpine.plugin(collapse);
Alpine.start();